import { render } from "./exwarehousehb.vue?vue&type=template&id=689a7e42"
import script from "./exwarehousehb.vue?vue&type=script&lang=js"
export * from "./exwarehousehb.vue?vue&type=script&lang=js"

import "./exwarehousehb.vue?vue&type=style&index=0&id=689a7e42&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__